module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.logMessageToShow),
      expression: "logMessageToShow"
    }],
    staticClass: "px-2 py-0 radius-normal fs-smaller bold",
    class: _vm.resultClass
  }, [_vm._v(_vm._s(_vm.foundResult.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d80f87"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduleTasks/components/taskResultLabel.vue
// module id = 2690
// module chunks = 0